import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import {
  SegwayInfo,
  SegwayInfoParams,
  SegwayInfoApiResponse,
} from "./SegwayInfoType";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";

export const fetchAsyncSegwayInfo: any = createAsyncThunk<
  SegwayInfoParams,
  SegwayInfoApiResponse
>("SegwayInfo/get", async () => {
  const response = await axiosSettings.get("api-admin/mobility?page_size=0");
  return response.data;
});

const initialState: SegwayInfo = {
  segwayInfo: null,
  updatedTime: "",
  loading: false,
  error: "",
};

const SegwayInfoSlice = createSlice({
  name: "SegwayInfo",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncSegwayInfo.fulfilled, (state, action) => {
      if (action.payload.status === "Success") {
        state.segwayInfo = action.payload.data.result.data;
        state.updatedTime = GetTime();
        state.error = "";
      } else {
        state.error = action.payload.data;
      }
      state.loading = false;
    });
    builder.addCase(fetchAsyncSegwayInfo.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncSegwayInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export const segwayInfoState = (state: RootState) =>
  state.SegwayInfo.segwayInfo;
export const segwayInfoError = (state: RootState) => state.SegwayInfo.error;
export const segwayInfoLoading = (state: RootState) => state.SegwayInfo.loading;
export const segwayInfoUpdatedTime = (state: RootState) =>
  state.SegwayInfo.updatedTime;

export default SegwayInfoSlice.reducer;
